import { createSelector } from 'reselect';
import * as fromReportParameterOptions from './report-parameter-options.reducer';

export interface ReportParameterOptionsDomainState {
  [fromReportParameterOptions.reportParameterOptionsFeatureKey]: fromReportParameterOptions.ReportParameterOptionsFeatureState;
}

export const selectReportParameterOptionsState = (state: ReportParameterOptionsDomainState) =>
  state[fromReportParameterOptions.reportParameterOptionsFeatureKey];

export const getReportParameterOptions = createSelector(
  selectReportParameterOptionsState,
  (reportParameterOptions) => reportParameterOptions.options
);

export const getReportParameterOptionsLoading = createSelector(
  selectReportParameterOptionsState,
  (reportParameterOptions) => reportParameterOptions.optionsLoading
);

export const getIsComplete = createSelector(selectReportParameterOptionsState, (state) => state.isComplete);
export const getError = createSelector(selectReportParameterOptionsState, (state) => state.error);
